module.exports = __webpack_public_path__ + "img/loss-clevik.1e9cb9b7.png";